/**
 * @Description 职工薪酬成本
 */

import { FC, useEffect } from 'react';
import TableModule from './TableModule';
import { EmployeeCompensationCostConfig, EmployeeCompensationCostNames } from '../ts-config';
import { isNotEmpty } from '@lhb/func';
import { Form } from 'antd';
import { fieldNameEmployeeCost } from './fieldname';
import { fixIntParam } from './transfer2value';

const EmployeeCompensationCost: FC<any> = ({
  form,
  formItemData,
  disabled,
  onChange
}) => {
  // 导购月均工资（第一年）
  const monthlySalaryOfShoppingGuideFirst: any = Form.useWatch(
    fieldNameEmployeeCost(true, EmployeeCompensationCostNames.monthlySalaryOfShoppingGuide),
    form
  );
  // 导购月均工资（第二年）
  const monthlySalaryOfShoppingGuideSecond: any = Form.useWatch(
    fieldNameEmployeeCost(false, EmployeeCompensationCostNames.monthlySalaryOfShoppingGuide),
    form
  );

  /**
   * @description 职工薪酬
   */
  useEffect(() => {
    const name = fieldNameEmployeeCost(true, EmployeeCompensationCostNames.employeeSalary);
    const val: any = calcEmployeeSalary(monthlySalaryOfShoppingGuideFirst);
    form.setFieldValue(name, val);
  }, [monthlySalaryOfShoppingGuideFirst]);

  useEffect(() => {
    const name = fieldNameEmployeeCost(false, EmployeeCompensationCostNames.employeeSalary);
    const val: any = calcEmployeeSalary(monthlySalaryOfShoppingGuideSecond);
    form.setFieldValue(name, val);
  }, [monthlySalaryOfShoppingGuideSecond]);

  /**
   * @description 职工薪酬
   * @param monthlySalaryOfShoppingGuide 导购月均工资
   * @return
   *
   * 导购月均工资*12*（1+0.1+0.05）
   */
  const calcEmployeeSalary = (monthlySalaryOfShoppingGuide) => {
    return isNotEmpty(monthlySalaryOfShoppingGuide) ? fixIntParam((+monthlySalaryOfShoppingGuide) * 12 * (1 + 0.1 + 0.05)) : null;
  };

  return (
    <TableModule
      moduleConfig={EmployeeCompensationCostConfig}
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default EmployeeCompensationCost;
